import { SelectOption } from '@anytag/shared-types';
import { SelectOptionValue } from './types';

export const getOptionValue = (opt: SelectOption<string>): string => opt.value;

export const getOptionLabel = (opt: SelectOption<string>) => opt.label ?? opt.value;

export const getValuesArray = <TOption extends SelectOption<string>>({
  value,
  options,
  multiple
}: {
  multiple?: boolean;
  options?: TOption[];
  value?: SelectOptionValue<TOption> | SelectOptionValue<TOption>[];
}): SelectOptionValue<TOption>[] =>
  typeof value === 'undefined' // empty string still considered as a valid value
    ? []
    : multiple
      ? (value as SelectOptionValue<TOption>[])
      : // Empty string '' still considered as a valid value if options contains an option with value ''
        value || (value === '' && options?.length && options.findIndex((opt) => opt.value === value) !== -1)
        ? [value as SelectOptionValue<TOption>]
        : [];

// Flatten all selectable values includes submenu items if the option has submenu
export const getAllSelectableValues = <TOption extends SelectOption<string>>(options: TOption[]) =>
  options.flatMap((opt) => (opt.submenu?.length ? opt.submenu.map((s) => getOptionValue(s)) : [getOptionValue(opt)]));

// Helper to find option (including submenu items) by value
export const getOptionByValue = <TOption extends SelectOption<string>>(options: TOption[], val: string) => {
  for (const opt of options) {
    if (getOptionValue(opt) === val) return opt;

    if (opt.submenu) {
      const found = opt.submenu.find((s) => getOptionValue(s) === val);

      if (found) return found;
    }
  }
  return undefined;
};
